import { Identifiable } from "./identifiable";
import { SeriesElement } from "./SeriesElement";
import { Series } from "./Series";
import { PatientMeta } from "../view/patient-meta";
import { ViewStudy } from "../view/view-study";
import { sortBy } from "lodash-es";
import { SeriesMeta } from "../view/series-meta";
import { ViewSendingStatus } from "../view/view-sending-status";

export class Study implements Identifiable {
    id: string;
    description: string;
    date: string;
    time: string;
    protocolName: string;
    accessionId: string;
    data: Map<string, Series>;
    filesNumber : number;

    constructor(seriesElement: SeriesElement) {
        this.id = seriesElement.getStudyId();
        this.description = seriesElement.getStudyDescription();
        this.date = seriesElement.getStudyDate();
        this.time = seriesElement.getStudyTime();
        this.protocolName = seriesElement.getStudyProtocolName();
        this.accessionId = seriesElement.getStudyAccessionId();
        this.data = new Map();
    }

    getId(): string {
        return this.id;
    }

    addSeriesElement(e: SeriesElement) {
        let series: Series | undefined = this.data.get(e.getSeriesId());
        if (!series) {
            series = new Series(e);
            this.data.set(e.getSeriesId(), series);
        }
        series.addSeriesElement(e);
    }

    getDescription(): string {
        return this.description;
    }

    getDate(): string {
        return this.date;
    }

    getTime(): string {
        return this.time;
    }

    getProtocolName(): string {
        return this.protocolName;
    }

    getAccessionId(): string {
        return this.accessionId;
    }

    convertToViewStudy(patient: PatientMeta): ViewStudy {
        const modalities: Set<string> = new Set<string>();
        return {
            data: {
                id: this.id,
                description: this.description,
                date: this.date,
                time: this.time,
                protocolName: this.protocolName,
                accessionId: this.accessionId,
                patient: patient,
                series: sortBy([...this.data.values()].map((e : Series) => this.mergeSeriesModalities(e, modalities)), [s => s.id]),
                filesNumber: this.numberOfFiles()
            },
            viewModality: modalities,
            status: {
                selected: false,
                patientNotEqual: false,
                sendingStatus: ViewSendingStatus.NOT_SENT
            }
        };
    }

    private numberOfFiles () : number {
        let num = 0;
        this.data.forEach(series => {
            num += series.data.size;
        });
        return num;
    }

    private mergeSeriesModalities(s: Series, modalitities: Set<string>): SeriesMeta {
        modalitities.add(s.modality);
        return s.convert();
    }

}
